import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUserLock, faUserCheck, faUserXmark } from '@fortawesome/free-solid-svg-icons'

export default function ManagerApprovalIcons(props) {
  const tooltipDirection = props.tooltipDirection ? 'has-tooltip-' + props.tooltipDirection : 'has-tooltip-right';
  let tooltipText = ''

  switch (props.type) {
    case 'mgr_approval_status_required':
      if (props.row && props?.row?.manager_approval) {
        tooltipText = props?.dropdownOptions.find((x) => x?.id === props?.row?.manager_approval?.mgr_approval_type_dropdown_option_id)?.name + ": Approval Required"
      } else {
        tooltipText = `Manager approval is required`
      }
      return (
        <span
          className={`lox-no-border ml-1 has-tooltip-arrow has-tooltip-multiline ${tooltipDirection} has-tooltip-danger has-text-left`}
          data-tooltip={tooltipText}
        >
          <FontAwesomeIcon icon={faUserLock} className="has-text-danger" />
        </span>
      )
    case 'mgr_approval_status_approved':
      if (props.row && props?.row?.manager_approval) {
        tooltipText = props?.dropdownOptions.find((x) => x?.id === props?.row?.manager_approval?.mgr_approval_type_dropdown_option_id)?.name + ": Approved By " + props?.row?.manager_approval?.manager_user?.label + ". Reason: " + props?.row?.manager_approval?.description
      } else {
        tooltipText = `Manager approval was granted`
      }
      return (
        <span
          className={`lox-no-border ml-1 has-tooltip-arrow has-tooltip-multiline ${tooltipDirection} has-tooltip-success has-text-left`}
          data-tooltip={tooltipText}
        >
          <FontAwesomeIcon icon={faUserCheck} className="has-text-success" />
        </span>
      )
    case 'mgr_approval_status_declined':
      if (props.row && props?.row?.manager_approval) {
        tooltipText = props?.dropdownOptions.find((x) => x?.id === props?.row?.manager_approval?.mgr_approval_type_dropdown_option_id)?.name + ": Declined By " + props?.row?.manager_approval?.manager_user?.label + ". Reason: " + props?.row?.manager_approval?.description
      } else {
        tooltipText = `Manager approval was denied`
      }
      return (
        <span
          className={`lox-no-border ml-1 has-tooltip-arrow has-tooltip-multiline ${tooltipDirection} has-tooltip-danger has-text-left`}
          data-tooltip={tooltipText}
        >
          <FontAwesomeIcon icon={faUserXmark} className="has-text-danger" />
        </span>
      )
    case 'mgr_approval_status_pending':
      return (
        <span
          className={`lox-no-border ml-1 has-tooltip-arrow has-tooltip-multiline ${tooltipDirection} has-tooltip-danger has-text-left`}
          data-tooltip={`${tooltipText ? tooltipText : "Manager approval is required and pending decision"}`}
        >
          <FontAwesomeIcon icon={faUserLock} className="has-text-danger" />
        </span>
      )
    default:
      return null
  }
}
